import React, {useEffect} from 'react'
import {Redirect, Route, Switch, useLocation} from 'react-router-dom'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {NewPassword} from './components/NewPassword'
import {EmailSuccess} from './components/EmailSuccess'
import {ResetPassword} from './components/ResetPassword'
import {UpdatePassword} from './components/UpdatePassword'
import AuthBrandedLayout from './components/AuthBrandedLayout'
import {OtpValidation} from './components/OtpValidation'
import {AuthenticatorValidation} from './components/AuthenticatorValidation'
import SingleSignOn from './components/SingleSignOn'
import Callback from './Callback'
import InstantLogin from './components/InstantLogin'
import {InstantOtpValidation} from './components/InstantOTPValidation'
export const applicationTypeName = window.__RUNTIME_CONFIG__.REACT_APP_NAME

// Paths that render inside the branded split-screen shell (gradient panel on the
// left, logo + form card on the right). Everything else renders bare.
const brandedLayoutPaths = ['/auth/login', '/auth/authenticator']

export function AuthPage() {
  const {pathname} = useLocation()
  // The logo / application name / body background for the branded shell now live
  // in AuthBrandedLayout, shared with AuthInit's profile-error screen.
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <>
      {brandedLayoutPaths.includes(pathname) ? (
        <AuthBrandedLayout>
          <Switch>
            <Route path='/auth/login/:id?' component={Login} />
            <Route path='/auth/set-password/:id?' component={NewPassword} />
            <Route path='/auth/forgot-password' component={ForgotPassword} />
            <Route path='/auth/verify-otp' component={OtpValidation} />
            <Route path='/auth/authenticator' component={AuthenticatorValidation} />
            <Route path='/auth/reset-password/:id' component={ResetPassword} />
            {/* <Route path='/auth/verify-user' component={VerifyUser} /> */}

            <Route path='/callback' component={Callback} />
            <Route path='/auth/success' component={EmailSuccess} />
            <Route path='/auth/update-password/:id?' component={UpdatePassword} />
            <Route path='/sso' component={SingleSignOn} />

            {/* {getToken && ( */}

            {/* )} */}

            <Redirect from='/auth' exact={true} to={'/auth/login'} />
            <Redirect to={'/auth/login'} />
          </Switch>
        </AuthBrandedLayout>
      ) : (
        <Switch>
          <Route path='/sso' component={SingleSignOn} />
          <Route path='/auth/instant-login/:id?' component={InstantLogin} />
          <Route path='/auth/instant-verify-otp' component={InstantOtpValidation} />
          <Route path='/auth/login/:id?' component={Login} />
          <Route path='/auth/set-password/:id?' component={NewPassword} />
          <Route path='/auth/forgot-password' component={ForgotPassword} />
          <Route path='/auth/verify-otp' component={OtpValidation} />
          <Route path='/auth/authenticator' component={AuthenticatorValidation} />
          <Route path='/auth/reset-password/:id' component={ResetPassword} />
          {/* <Route path='/auth/verify-user' component={VerifyUser} /> */}

          <Route path='/callback' component={Callback} />
          <Route path='/auth/success' component={EmailSuccess} />
          <Route path='/auth/update-password/:id?' component={UpdatePassword} />
          <Redirect to={applicationTypeName === 'instant' ? '/auth/instant-login' : '/auth/login'} />
        </Switch>
      )}
    </>
  )
}
